import {useEffect, useState} from 'react';


const useNewClassImages = (open, getOpen) => {
    const [activeHover, setActiveHover] = useState('');

    const isOpenModalGallery = (open) => open;

    const onMouseOverImage = (e, img) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveHover(img.title);
    };

    const onMouseOverContainer = (e) => {
        if (!e.target.id && !(e.target.nodeName === 'path')) {
            e.preventDefault();
            e.stopPropagation();
            setActiveHover('');
        } else if (e.target.id && e.target.id.split('_')[0] !== 'img') {
            e.preventDefault();
            e.stopPropagation();
            setActiveHover('');
        }
    };

    useEffect(() => {
        getOpen && getOpen(open);
    }, [open]);


    return {activeHover, onMouseOverImage, onMouseOverContainer, isOpenModalGallery};

};

export default useNewClassImages;
